<template>
  <div class="container">
    <section class="section intro">
      <div class="background">
        <img src="./../assets/images/home_banner.jpg" alt="background"/>
      </div>
      <div class="content">
        <p class="section-header" v-html="$translations.get('bodies_header')">Our expertise</p>
        <p class="section-title" v-html="$translations.get('bodies_title')">Please select body of interest</p>
        <div class="buttons">
          <router-link class="outline-button anim-rtl" to="/public-bodies">
            <span class="background"></span>
            <span v-html="$translations.get('bodies_public')"></span>
          </router-link>
          <span class="separator"></span>
          <router-link class="outline-button anim-ltr" to="/private-bodies">
            <span class="background"></span>
            <span v-html="$translations.get('bodies_private')"></span>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'PublicPrivateBodies',
  }
</script>

<style lang="scss" scoped>
  @import '../static/css/style';

  .section {

    &.intro {

      .background img {
        @include absolute-stretch();

        &:nth-child(1) {
          object-position: top !important;
        }

        &:nth-child(2) {
          object-position: bottom !important;
        }
      }

      .content {
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .buttons {
          position: relative;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          font-size: 1.2vw;
          margin-top: 3em;

          .outline-button {
            position: relative;
            color: #fff;
            letter-spacing: 0.3em;
            font-size: 0.7rem;
            padding: 0.8em 2.5em;
            font-family: 'OpenSans-Bold', sans-serif;
            text-transform: uppercase;
            cursor: pointer;
            text-decoration: none;
            @include transition(color $default-ease 200ms);
            $border-width: 0.1em;

            &::before {
              content: '';
              display: block;
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              box-sizing: border-box;
              border-top: $border-width solid #fff;
              border-right: $border-width solid #fff;
            }

            &::after {
              content: '';
              display: block;
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              box-sizing: border-box;
              border-bottom: $border-width solid #fff;
              border-left: $border-width solid #fff;
            }

            .blue {
              color: $accent-color;
            }

            &.anim-ltr {

              &::before {
                top: 0;
                left: 0;
                bottom: auto;
                right: auto;
              }

              &::after {
                top: auto;
                left: auto;
                bottom: 0;
                right: 0;
              }
            }

            &.anim-rtl {

              &::before {
                top: 0;
                left: auto;
                bottom: auto;
                right: 0;
              }

              &::after {
                top: auto;
                left: 0;
                bottom: 0;
                right: auto;
              }
            }

            .background {
              z-index: -1;
              @include absolute-stretch();
              background: #fff;
              -webkit-transform-origin: center bottom;
              transform-origin: center bottom;
              @include transition(transform $default-ease 200ms);
              @include transform(scaleY(0))
            }

            &:hover {
              color: #000;

              .background {
                @include transform(scaleY(1))
              }
            }
          }

          .separator {
            width: 0.1rem;
            height: 2rem;
            margin: 0 2rem;
            display: block;
            background: #fff;
          }
        }
      }
    }

    @include media-query(medium) {

      &.intro {

        .content {

          .buttons {
            flex-direction: column;

            .separator {
              height: 0.1rem;
              width: 2rem;
              margin: 2rem 0;
              display: block;
              background: #fff;
            }
          }
        }
      }
    }
  }

  .loaded {

    .intro {

      .background img {

        &:nth-child(1) {
          @include animation(zoomOut 2s ease-out 0s 1 both);
        }

        &:nth-child(2) {
          @include animation(fadeIn 2s $default-ease 0s 1 both);
        }
      }

      .section-header {
        @include animation(fadeIn 1s $default-ease 700ms 1 both);
      }

      .section-title {
        @include animation(fadeIn 1s $default-ease 900ms 1 both);
      }

      .separator {
        -webkit-transform-origin: center top;
        transform-origin: center top;
        @include animation(heightStretch 1s $default-ease 1100ms 1 both);
      }

      .outline-button {
        @include animation(fadeIn 2s $default-ease 0s 1 both);

        &.anim-ltr {

          &::before {
            @include animation(maxWidthStretch 500ms ease-out 0s 1 both, maxHeightStretch 500ms ease-out 500ms 1 both);
          }

          &::after {
            @include animation(maxWidthStretch 500ms ease-out 1s 1 both, maxHeightStretch 500ms ease-out 1.5s 1 both);
          }
        }

        &.anim-rtl {

          &::before {
            @include animation(maxWidthStretch 500ms ease-out 0s 1 both, maxHeightStretch 500ms ease-out 1.5s 1 both);
          }

          &::after {
            @include animation(maxHeightStretch 500ms ease-out 500ms 1 both, maxWidthStretch 500ms ease-out 1s 1 both);
          }
        }
      }
    }

    @include media-query(medium) {

      .intro {

        .separator {
          -webkit-transform-origin: center center;
          transform-origin: center center;
          @include animation(widthStretch 1s $default-ease 1100ms 1 both);
        }
      }
    }
  }
</style>
